import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { UnauthorizedError } from './errors/unauthorized-error';
import { AuthenticationService } from './../core/authentication.service';

@Injectable()
export class HttpExceptionInterceptor implements HttpInterceptor {
  private readonly corsErrorStatusCode: number = 0;

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.error instanceof ErrorEvent) {
          // client-side error
          return throwError(new Error(`Error: ${error.error.message}`));
        }

        // server-side error
        if (error.status === 401 || error.status === 403) {
          this.authenticationService.logout();
          this.router.navigateByUrl('/unauthorized');
          return throwError(new UnauthorizedError());
        }
        // graphql error response
        if (error.status === 400) {
          return throwError(error);
        }
        if (error.status >= 400 || error.status === this.corsErrorStatusCode) {
          const statusId =
            error.status === this.corsErrorStatusCode ? 404 : error.status;
          return throwError(
            new Error(`Cannot load ${request.url}. Http status ${statusId}.`)
          );
        }

        return throwError(
          `Error Code: ${error.status}\nMessage: ${error.message}`
        );
      })
    );
  }
}
